import React, { useEffect, useState } from 'react';
import styles from './BenefitsValidate.module.scss';
import GenericModal from '../LineCheckV3/GenericModal';
import RichText from '../richtext';
import { createPortal } from 'react-dom';
import { fetchSubscriptionData } from '../../services/LineTableService';
import {
  CAPSINTERNET,
  POSTPAID,
  SUNRISEINTERNET,
  SUNRISEMOBILE
} from '../../Analytics/AnalyticsConstants';
import { CheckBenefitsMatch } from './Benefits';
import { LoginBasicPropConfig } from '../../services/LoginBasicPropConfig';
import LoginModalV2 from '../login/LoginModalV2';

const BenefitsValidate = ({
  content,
  authData: _authData,
  loginContent,
  metadata,
  afterLoginContent,
  createCartCall,
  extraContent,
  basicConfigUrl,
  selectedExistingOption,
  setShowBenefit,
  setLoginSuccess,
  isProdEnv
}: any) => {
  const [modalClick, updateModalClick] = useState(true);
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [afterLogin, setAfterLogin] = useState<boolean>(false);
  const [userSubscriptionData, setUserSubscriptionData] = useState([]);
  const [selectedArray, setselectedArray] = useState<any>([]);
  const [subscribedArray, setSubscribedArray] = useState<any>([]);
  const [subscriptionFailure, setSubscriptionFailure] = useState(false);

  const endpoint = `${basicConfigUrl}inf/customer-management/subscriptions`;
  LoginBasicPropConfig.create({ baseURL: basicConfigUrl });
  const userBenefitsSelectedCheckBox = selectedExistingOption;
  const subscription_name = extraContent?.subscriptionName;

  const handleClick = () => {
    updateModalClick(!modalClick);
    setShowBenefit(false);
  };

  const loginClick = () => {
    updateModalClick(false);
    setShowLogin(!showLogin);
  };

  //once login success set login pop up false and proceed to checkout section
  const onLoginSuccess = () => {
    setShowLogin(false);
    setLoginSuccess();
    try {
      fetchSubscriptionData('POSTPAID,FIXNET', endpoint)
        ?.then((resp: any) => {
          if (resp?.subscriptionData == 204) {
            setSubscriptionFailure(true);
            updateModalClick(true);
            setAfterLogin(true);
          } else {
            setUserSubscriptionData(resp?.subscriptionData);
            setAfterLogin(true);
            setSubscriptionFailure(false);
          }
        })
        .catch((error: any) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('error--->', err);
    }
  };
  /*the portal position for the the dotloader*/
  const portalPosition: any =
    typeof window !== undefined && document.getElementById('static-linetable');

  useEffect(() => {
    if (userSubscriptionData?.length > 0) {
      const selectionArray = [],
        subscriptionArray = [];
      if (userBenefitsSelectedCheckBox?.includes(SUNRISEMOBILE)) {
        selectionArray.push(subscription_name?.replace('{name}', SUNRISEMOBILE));
      }
      if (userBenefitsSelectedCheckBox?.includes(SUNRISEINTERNET)) {
        selectionArray.push(subscription_name?.replace('{name}', SUNRISEINTERNET));
      }
      setselectedArray(selectionArray);
      const benefitsMatch = CheckBenefitsMatch(userBenefitsSelectedCheckBox, userSubscriptionData);

      if (!benefitsMatch) {
        updateModalClick(true);
        const subscriptionData = new Set(
          userSubscriptionData?.map((data: any) => {
            return data?.ratePlanType;
          })
        );
        if (subscriptionData?.has(POSTPAID)) {
          subscriptionArray.push(subscription_name?.replace('{name}', SUNRISEMOBILE));
        }
        if (subscriptionData?.has(CAPSINTERNET)) {
          subscriptionArray.push(subscription_name?.replace('{name}', SUNRISEINTERNET));
        }
        setSubscribedArray(subscriptionArray);
      } else {
        createCartCall();
      }
    }
  }, [userSubscriptionData]);

  return (
    <div>
      <GenericModal
        modalState={modalClick}
        handler={handleClick}
        showFooter={false}
        noCloseButton={false}
        backDrop={true}
        width='400px'
        height='150px'
        bodyPadding={'16px'}
        id='mobile-benefits'
      >
        <div className={styles.container}>
          {!subscriptionFailure && content?.title && (
            <h4 className={styles.title}>{content?.title}</h4>
          )}

          {content?.description && !afterLogin && (
            <div className={styles.description}>
              <RichText content={content?.description} />
            </div>
          )}
          {afterLogin && afterLoginContent && !subscriptionFailure && (
            <>
              {selectedArray?.length > 0 && (
                <div className={styles.selectedSubDesc}>
                  <div>{afterLoginContent?.selectedProductsTitle}:</div>
                  <ul>
                    {(selectedArray || [])?.map((sub: string) => (
                      <li>{sub}</li>
                    ))}
                  </ul>
                </div>
              )}
              {subscribedArray?.length > 0 && (
                <div className={styles.subscriptionDesc}>
                  <div>{afterLoginContent?.ownedProductsTitle}:</div>
                  <ul>
                    {(subscribedArray || [])?.map((sub: string) => (
                      <li>{sub}</li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}

          {!afterLogin && !subscriptionFailure && (
            <div>
              <div className={styles['buttons-container']}>
                {content?.cancelBtn && (
                  <div className='secondarybutton' onClick={handleClick}>
                    {content?.cancelBtn}
                  </div>
                )}
                {content?.loginBtn && (
                  <div className='primarybutton' onClick={loginClick}>
                    {content?.loginBtn}
                  </div>
                )}
              </div>
            </div>
          )}
          {subscriptionFailure && extraContent?.noSubscriptionTitle && (
            <h4 className={styles.title}>{extraContent?.noSubscriptionTitle}</h4>
          )}
          {afterLoginContent?.updateBenefitBtn && afterLogin && (
            <div className='primarybutton' onClick={handleClick}>
              {afterLoginContent?.updateBenefitBtn}
            </div>
          )}
        </div>
      </GenericModal>
      {showLogin &&
        loginContent &&
        portalPosition &&
        createPortal(
          <LoginModalV2
            content={loginContent}
            closeLogin={() => {
              setShowLogin(false);
            }}
            metadata={metadata}
            onSuccess={onLoginSuccess}
            isProdEnv={isProdEnv}
            />,
          portalPosition
        )}
    </div>
  );
};
export default BenefitsValidate;
